import React, { useEffect, useState } from "react";
import { Alert, Spin } from "antd";
import SheetDrawer from "../../../components/sheet/SheetDrawer";
import { getPackageMetrics, getQuickTripMetrics } from "../../../services/packages-service";
import BookingMetrics from "./BookingMetrics";

/**
 * Booking metrics for one package or quick trip. `listing` is the table row
 * ({ id, title, ... }) or null when closed; `type` is "PACKAGE" | "QUICK_TRIP".
 */
const ListingMetricsDrawer = ({ listing, type, onClose }) => {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!listing) return undefined;
    let cancelled = false;
    setMetrics(null);
    setError(null);
    setLoading(true);
    const fetchMetrics = type === "QUICK_TRIP" ? getQuickTripMetrics : getPackageMetrics;
    fetchMetrics(listing.id)
      .then((data) => !cancelled && setMetrics(data))
      .catch((err) => !cancelled && setError(err.message))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [listing, type]);

  return (
    <SheetDrawer
      open={!!listing}
      onClose={onClose}
      width={640}
      title={listing ? `Metrics — ${listing.title}` : "Metrics"}
      destroyOnClose
    >
      {loading && <Spin />}
      {error && <Alert type="error" showIcon message="Couldn't load metrics" description={error} />}
      {metrics && <BookingMetrics metrics={metrics} />}
    </SheetDrawer>
  );
};

export default ListingMetricsDrawer;
